import { API } from "../config/config";

const DashboardService = {
  getInventoryDashboard: (storeId, params) => getInventoryDashboard(storeId, params),
  getReplenishmentAnalysis: (storeId, params) => getReplenishmentAnalysis(storeId, params),
  getProfitabilityAnalysis: (storeId, params) => getProfitabilityAnalysis(storeId, params),
  getRotationAnalysis: (storeId, params) => getRotationAnalysis(storeId, params),
  getInventoryByCategory: (storeId) => getInventoryByCategory(storeId),
  getLowStockAlerts: (storeId, params) => getLowStockAlerts(storeId, params),
  getProductStats: (articleId, storeId, params) => getProductStats(articleId, storeId, params),
  getCashRegisterDashboard: (storeId) => getCashRegisterDashboard(storeId),
  getCashRegisterHistory: (storeId, params) => getCashRegisterHistory(storeId, params),
};

const getInventoryDashboard = async (storeId, params = {}) => {
  try {
    const queryParams = new URLSearchParams();
    
    if (params.date_from) queryParams.append('date_from', params.date_from);
    if (params.date_to) queryParams.append('date_to', params.date_to);
    if (params.low_stock_threshold) queryParams.append('low_stock_threshold', params.low_stock_threshold);
    
    const queryString = queryParams.toString();
    const url = `/dashboard/inventory/${storeId}${queryString ? `?${queryString}` : ''}`;
    
    const response = await API.get(url);
    return response.data;
  } catch (err) {
    console.error('Error getting inventory dashboard:', err);
    throw new Error(err);
  }
};

const getReplenishmentAnalysis = async (storeId, params = {}) => {
  try {
    const queryParams = new URLSearchParams();
    
    if (params.date_from) queryParams.append('date_from', params.date_from);
    if (params.date_to) queryParams.append('date_to', params.date_to);
    if (params.limit) queryParams.append('limit', params.limit);
    
    const queryString = queryParams.toString();
    const url = `/dashboard/replenishment/${storeId}${queryString ? `?${queryString}` : ''}`;
    
    const response = await API.get(url);
    return response.data;
  } catch (err) {
    console.error('Error getting replenishment analysis:', err);
    throw new Error(err);
  }
};

const getProfitabilityAnalysis = async (storeId, params = {}) => {
  try {
    const queryParams = new URLSearchParams();
    
    if (params.date_from) queryParams.append('date_from', params.date_from);
    if (params.date_to) queryParams.append('date_to', params.date_to);
    if (params.limit) queryParams.append('limit', params.limit);
    
    const queryString = queryParams.toString();
    const url = `/dashboard/profitability/${storeId}${queryString ? `?${queryString}` : ''}`;
    
    const response = await API.get(url);
    return response.data;
  } catch (err) {
    console.error('Error getting profitability analysis:', err);
    throw new Error(err);
  }
};

const getRotationAnalysis = async (storeId, params = {}) => {
  try {
    const queryParams = new URLSearchParams();
    
    if (params.date_from) queryParams.append('date_from', params.date_from);
    if (params.date_to) queryParams.append('date_to', params.date_to);
    if (params.limit) queryParams.append('limit', params.limit);
    
    const queryString = queryParams.toString();
    const url = `/dashboard/rotation/${storeId}${queryString ? `?${queryString}` : ''}`;
    
    const response = await API.get(url);
    return response.data;
  } catch (err) {
    console.error('Error getting rotation analysis:', err);
    throw new Error(err);
  }
};

const getInventoryByCategory = async (storeId) => {
  try {
    const url = `/dashboard/inventory-by-category/${storeId}`;
    
    const response = await API.get(url);
    return response.data;
  } catch (err) {
    console.error('Error getting inventory by category:', err);
    throw new Error(err);
  }
};

const getLowStockAlerts = async (storeId, params = {}) => {
  try {
    const queryParams = new URLSearchParams();
    
    if (params.threshold) queryParams.append('threshold', params.threshold);
    
    const queryString = queryParams.toString();
    const url = `/dashboard/low-stock-alerts/${storeId}${queryString ? `?${queryString}` : ''}`;
    
    const response = await API.get(url);
    return response.data;
  } catch (err) {
    console.error('Error getting low stock alerts:', err);
    throw new Error(err);
  }
};

const getProductStats = async (articleId, storeId, params = {}) => {
  try {
    const queryParams = new URLSearchParams();
    
    if (params.date_from) queryParams.append('date_from', params.date_from);
    if (params.date_to) queryParams.append('date_to', params.date_to);
    
    const queryString = queryParams.toString();
    const url = `/dashboard/product/${articleId}/${storeId}${queryString ? `?${queryString}` : ''}`;
    
    const response = await API.get(url);
    return response.data;
  } catch (err) {
    console.error('Error getting product stats:', err);
    throw new Error(err);
  }
};

const getCashRegisterDashboard = async (storeId) => {
  try {
    const response = await API.get(`/dashboard/cashregister/${storeId}`);
    return response.data;
  } catch (err) {
    console.error('Error getting cash register dashboard:', err);
    throw new Error(err);
  }
};

const getCashRegisterHistory = async (storeId, params = {}) => {
  try {
    const queryParams = new URLSearchParams();
    if (params.date_from) queryParams.append('date_from', params.date_from);
    if (params.date_to) queryParams.append('date_to', params.date_to);
    const qs = queryParams.toString();
    const response = await API.get(`/dashboard/cashregister/${storeId}/history${qs ? `?${qs}` : ''}`);
    return response.data;
  } catch (err) {
    console.error('Error getting cash register history:', err);
    throw new Error(err);
  }
};

export default DashboardService;
